module.exports = __webpack_public_path__ + "img/icon_provider.cfa022a7.svg";